import type { BanDich } from '../../types';
import type { viBot } from './bot.vi';

export const enBot: Pick<BanDich, keyof typeof viBot> = {
  troLyAiBot: {
    tieuDe: 'AI chatbot settings',
    phuDe: 'Bots that are on and can answer appear on the “Chat with a bot” screen.',
    themChatbot: 'Add chatbot',
    chuaCoBot: 'No chatbots yet.',
    themBotDauTien: 'Add the first bot.',
    quanTriTao: 'An administrator creates bots.',
    chonBot: 'Select a chatbot on the left to see its settings.',
    danhSachBot: 'Chatbot list',
    timBot: 'Search chatbots',
    khongTimThayBot: 'No chatbots match the keyword.',
    tat: 'off',
    dangChay: 'Running',
    dangBat: 'On',
    dangTat: 'Off',
    tatTuDong: 'Off because there are no sources left to search.',
    nguonDangTat: '{{n}} sources · off',
    moBot: 'Open a chat with {{ten}}',
    xacNhanXoa: 'Delete chatbot “{{ten}}”?',
    xacNhanXoaGhi: "The chatbot's settings will be deleted and can't be restored. Its documents and data are not affected.",
    xoaChatbot: 'Delete chatbot',
    daXoa: 'Chatbot deleted.',
    daLuuCauHinh: 'Settings saved.',
    daTaoChatbot: 'Chatbot created.',
    taoChatbot: 'Create chatbot',
    thuTroChuyen: 'Try chatting',
    botTuTatDam: 'This bot was turned off automatically',
    botTuTatSau: 'because its last source was deleted. Attach a knowledge base or a data source on the Knowledge tab, then turn it back on.',
    conViec: '{{n}} things left before the bot can be turned on',
    viecDatTen: 'Name the bot',
    viecGanNguon: 'Attach at least one knowledge base or data source',
    chatbotMoi: 'New chatbot',
    chuaTao: 'Not created',
    botChuaTao: 'The bot has not been created yet — enter a name, then select Create chatbot.',
    coThayDoi: 'Unsaved changes on {{n}} tabs',
    daLuuHet: 'All changes saved',
    hoanTac: 'Undo',
    tabCanSua: 'needs fixing',
    tabChuaLuu: 'has unsaved changes',
    boThayDoiHoi: 'Discard unsaved changes?',
    boThayDoiGhi: "You're in the middle of editing this bot. If you leave now, your unsaved changes will be lost.",
    boThayDoi: 'Discard changes',
    mucCoBan: 'Basic information',
    tenChatbot: 'Chatbot name',
    moTaNgan: 'Short description',
    mucDich: 'Purpose',
    loiChao: 'Greeting',
    mucNguon: 'Knowledge sources',
    mucNguonMo: "Leaving both empty means the bot can't look anything up — not that it looks up everything.",
    khongNguonKO: 'No source selected. In “within scope” mode the bot answers “not found” to every question, so it can\'t be turned on.',
    khongNguonMo: "No source selected. The bot still answers from the model's general knowledge, but its answers aren't based on the organization's documents or data.",
    boTriThuc: 'Knowledge bases (documents)',
    chuaCoBo: 'No knowledge bases yet.',
    nguonSoLieu: 'Data sources (figures)',
    chonNhieu: 'choose one or more',
    chuaCoNguon: 'No sources yet.',
    tranNguon: 'Up to {{n}} sources — each source is a separate lookup for every question.',
    traWeb: "Organization's website",
    traWebMo: 'Used when the data and documents can\'t answer — for example “do you deliver to other provinces”.',
    traWebGhi: 'One domain per line, without https:// or a path. A root domain includes its subdomains. Up to 20.',
    traWebRong: "not set — the bot doesn't search the web",
    traWebKhacGoc: 'Different from “Domains allowed to embed”: that field controls which pages can embed the chat widget, this one controls which pages the bot may read.',
    traWebViDu: 'company.com\nnews.company.com',
    mucCachTraLoi: 'How it answers',
    phamViTraLoi: 'Answer scope',
    modeKnowledgeOnly: 'Answer only within the documents',
    modeKnowledgeOnlyMo: "If it isn't in the documents or data, the bot says it doesn't know instead of guessing.",
    modeOpen: 'May answer beyond scope',
    modeOpenMo: "The bot may answer from the model's general knowledge. Those answers have no cited source.",
    trichNguon: 'Cite sources in answers',
    trichNguonMo: 'On: answers name the documents they cite (for example “According to quy_dinh.pdf, …”). Off: answers go straight to the content without naming files.',
    mucHuongDan: 'System instructions',
    mucHuongDanMo: "Tone and scope of answers. Don't put figures here — figures come from data sources, and numbers written here go stale without anyone noticing.",
    mucFaq: 'Frequently asked questions',
    mucFaqMo: 'Questions with ready-made answers that need no lookup. Use them where a prepared answer beats a search result.',
    cauHoi: 'Question',
    cauTraLoi: 'Answer',
    themCauHoi: 'Add question',
    xoaCauHoi: 'Delete question {{i}}',
    cauHoiSo: 'Question {{i}}',
    cauTraLoiSo: 'Answer {{i}}',
    mucKichBan: 'Scenarios',
    mucKichBanMo: 'When a question matches a situation, the bot follows a multi-step process. Unlike FAQs, scenarios match by situation, not by a specific question.',
    batKichBan: 'Turn on scenarios for this bot',
    themKichBan: 'Add scenario',
    chuaDatTen: '(unnamed)',
    xoaKichBan: 'Delete scenario {{ten}}',
    suaKichBan: 'Edit scenario {{ten}}',
    kbThongTin: '{{n}} required items',
    kbBuoc: '{{n}} steps',
    kbQuyTac: '{{n}} rules',
    kbChuaCoBuoc: 'no steps yet',
    kenhGiaoTiep: 'Communication channel',
    kenhGhi: 'Applies to both the embedded chat widget and the Chat with a bot screen. Text is always shown in all three options.',
    giongDoc: 'Voice',
    giongGhi: "Visitors to the embedded widget can't choose a voice, so choose it here.",
    giongChuaCo: 'The server has no voices yet — a Gemini key needs to be configured.',
    mucKhac: 'Other',
    luuLichSu: 'Save conversation history',
    vungNguyHiem: 'Delete this chatbot',
    tab: {
      tongQuan: 'Overview',
      triThuc: 'Knowledge',
      hanhVi: 'Behavior',
      giaoTiep: 'Communication',
      quyen: 'Access',
      nhung: 'Embed',
      nangCao: 'Advanced',
    },
    chonNguon: {
      dem: '{{n}} selected',
      demTran: '{{n}}/{{tong}} selected',
      chuaChon: 'Nothing selected.',
      tim: 'Search {{nhan}}',
      khongKhop: 'No items match the keyword.',
      chuaSanSang: 'Not ready ({{n}})',
    },
    kenh: {
      van_ban: 'Text only',
      van_banMo: 'Type and read. No microphone, no speech.',
      giong_noi: 'Voice',
      giong_noiMo: 'Microphone on, and answers are read aloud automatically.',
      ca_hai: 'Voice + text',
      ca_haiMo: 'Microphone and a speaker button — read aloud only when pressed.',
    },
  },

  troLyAiBotNhung: {
    nhungChuaChay: 'Not active yet',
    nhungChuaChayGhi: 'The chat bubble only appears when three conditions hold: the widget is open, the page\'s domain is in the list below, and the snippet is pasted exactly as shown.',
    moKhungRaNgoai: 'Allow embedding the chat widget externally',
    moKhungGhi: 'A bot running inside the system may still not be open to the internet.',
    dangMo: 'Open',
    dangDong: 'Closed',
    khoaKhongPhaiMatKhau: 'The embed key is not a password',
    khoaGhi: "The key sits in the page source, so anyone who views the source can read it.",
    khoaDsGocDam: 'The domain list',
    khoaDsGocSau: "stops other pages from embedding the bot, but doesn't stop someone calling it from a command-line tool.",
    khoaTranDam: 'The per-minute limit',
    khoaTranSau: 'is the only protection that still works against them.',
    khoaNhung: 'Embed key',
    anKhoa: 'Hide key',
    hienKhoa: 'Show key',
    saoChep: 'Copy',
    daSaoChep: '{{ten}} copied.',
    khongSaoChepDuoc: "The browser doesn't allow copying here — select the text and copy it manually.",
    khoa: 'key',
    doanMa: 'snippet',
    khoaGhiChu: "Generated by the platform and can't be edited. Masking here only avoids exposure while presenting — the key is still in your page source.",
    doanMaDan: 'Snippet to paste into the page',
    khoaApiHuongDan: 'Replace <TENANT_API_KEY> with a tenant API key: create one on the API keys screen and grant only tro-ly-ai:nhung:hoi. The key sits in public page source just like the embed key — allowed origins and rate limits are the real barrier.',
    saoChepDoanMa: 'Copy snippet',
    khoaSinhKhiLuu: 'The embed key is generated the first time you save with the widget open.',
    xoayKhoa: 'Issue a new key',
    xoayKhoaHoi: 'Issue a new embed key?',
    xoayKhoaCanhBao: "The old key stops working immediately, and every page embedding this bot won't show the chat bubble until its snippet is updated. This can't be undone.",
    xoayKhoaLam: 'Issue new key',
    xoayKhoaXong: 'New key issued. Send the new snippet to the pages you want to keep embedding.',
    gocDuocPhep: 'Domains allowed to embed',
    gocLaSao: 'set to * — every page on the internet can embed it',
    gocRong: 'empty — meaning no domain can embed it',
    gocGhiChu: 'One full address per line, including https:// and without a path, for example https://example.com. A single * line allows every domain.',
    gocViDu: 'https://company.com\nhttps://lookup.company.com\n\nor a single *  line to allow every origin',
    gocCanhBaoDam: 'Every domain is allowed.',
    gocCanhBaoSau: 'Any page on the internet can embed this bot. The only remaining protection is the per-minute limit below.',
    tranChung: 'Questions per minute — all visitors',
    tranMotNguoi: 'Questions per minute — per visitor',
    tranMotNguoiGhi: 'You need both: without a per-visitor limit, one person can use up the shared allowance.',
    vaiNhung: 'Role of the embedded bot',
    vaiNhungRong: 'No data access (recommended)',
    vaiNhungGhi: "Leave empty: the bot answers only from knowledge bases, FAQs and scenarios — it doesn't access data.",
    vaiNhungCanhBao: 'Role “{{vai}}” can read {{n}} tables in source “{{nguon}}”. Visitors on the public page will be able to read exactly those tables.',
    vaiNhungChuaCoNguon: "This bot has no data source attached, so choosing a role has no effect yet. Attach sources on the Knowledge tab.",
    vaiNhungTomTat: 'Role “{{vai}}” can read data in {{ok}}/{{tong}} of the bot\'s sources.',
    vaiNhungDongChuaTick: "“{{nguon}}”: no tables granted — the embedded bot won't be able to read this source.",
    vaiNhungDongToanBo: '“{{nguon}}”: whole-source access — anonymous visitors can read every table, including ones synced later.',
    vaiNhungDongChuaCapKhuon: "“{{nguon}}”: the role has no query templates granted — the embedded bot can't call any operation on this source.",
    vaiNhungConLai: '…and {{n}} more sources.',
    vaiNhungChuaCapKhuon: "Role “{{vai}}” has no query templates granted in source “{{nguon}}” — the embedded bot can't call any operation. Open Data permissions → By query template to grant them.",
    vaiNhungKhuon: 'Role “{{vai}}” can call query templates in source “{{nguon}}”. Visitors on the public page can ask about exactly the operations granted to this role.',
    vaiNhungChuaTick: "Role “{{vai}}” has no tables granted in source “{{nguon}}” — the embedded bot won't be able to read data. Open Data permissions, choose this source and grant access.",
    vaiNhungToanBoNguon: 'Role “{{vai}}” has the whole source “{{nguon}}” open — visitors on the public page can read every table, including ones added later. Consider switching to “By table”.',
    vaiNhungDangDo: "Checking this role's permissions on the bot's sources...",
    vaiNhungKhongDoDuoc: "Couldn't check this role's permissions. Review them on the Data permissions screen.",
    moHinhNhung: 'Answer model for the embedded bot',
    moHinhNhungMacDinh: 'Server default',
    moHinhNhungGhi: "Leave empty: the embedded bot uses the server's default model.",
    moHinhNhungDangDung: 'Using {{ma}}.',
    moHinhNhungThieuKhoa: "“{{ten}}” has no API key on the server — choosing it means the embedded bot can't answer. Choose another model, or leave it empty to use the default.",
    moHinhNhungLa: 'The server no longer offers “{{ten}}”. The embedded bot still answers, but with the default model rather than the one shown here. Choose a model from the list again.',
    moHinhNhungKhongDoDuoc: "Couldn't load the model catalog. The embedded bot still runs — it's not yet known whether this model is still available.",
    moHinhChuaCauHinh: 'not configured',
    tieuDeKhung: 'Widget title',
    mauChuDao: 'Primary color',
    chonMau: 'Choose primary color',
    mauSaiDang: 'The color must be # followed by 3 or 6 hexadecimal digits. The server rejects any other format.',
    viTri: 'Chat bubble position',
    gocDuoiPhai: 'Bottom right',
    gocDuoiTrai: 'Bottom left',
  },

  troLyAiBotQuyenTruyCap: {
    tieuDe: 'Who can use this bot',
    dem: '{{n}}/{{tong}} roles can see this bot',
    giaiThich: "Selected roles see the bot on the “Chat with a bot” screen and can chat with it. People with several roles get the combined permissions. The data the bot can read still follows the asker's role — set on the Data permissions screen.",
    luuRieng: 'Access is saved separately with the button below, not with the settings Save button, and takes effect even while the bot is off.',
    luu: 'Save access',
    hoanTac: 'Undo',
    daLuu: 'Bot access saved.',
    chuaTao: 'The bot has not been created yet',
    chuaTaoMoTa: 'Create the bot first, then come back to this tab to choose which roles can use it.',
    khongCoVai: 'The organization has no roles to grant yet.',
  },

  troLyAiBotKichBan: {
    them: 'Add new scenario',
    sua: 'Edit scenario',
    luu: 'Save scenario',
    ten: 'Scenario name',
    moTaNgan: 'Short description',
    moTaNganGhi: 'When this scenario applies — described in words, not as an expression.',
    cacBuoc: 'Conversation steps',
    cacBuocGhi: 'In order — “ask about income” before “propose a limit” is a different process from the reverse. For steps that must capture information from the customer, tick “Collect”: the bot asks in exactly this order and won\'t finish while anything is missing.',
    buocSo: 'Step {{i}}',
    quyTac: 'Rules to follow',
    quyTacGhi: "Prohibitions and constraints — true at every step, so they aren't numbered.",
    quyTacSo: 'Rule {{i}}',
    quyTacViDu: 'E.g. Never skip a step',
    duaLen: 'Move step {{i}} up',
    duaXuong: 'Move step {{i}} down',
    xoaBuoc: 'Delete step {{i}}',
    xoaQuyTac: 'Delete rule {{i}}',
    themBuoc: 'Add step',
    themQuyTac: 'Add rule',
    kieuCua: 'Type of {{ten}}',
    kieuVanBan: 'Text',
    kieuSo: 'Number',
    kieuDienThoai: 'Phone number',
    kieuEmail: 'Email',
    kieuNgay: 'Date',
    thuThap: 'Collect',
    thuThapGhi: 'This step must obtain a value from the customer',
    thuThapCua: 'Collect at step {{i}}',
    viDuBuoc: 'E.g. Ask for a phone number',
    gopTuBanKhaiCu: '{{n}} required items declared in the old format have been merged into the step list below. Save once to switch to the new format.',
  },

  troLyAiBotGiong: {
    giongDoc: 'Voice',
    dungNgheThu: 'Stop preview',
    ngheThuHong: "Couldn't preview — {{loi}}",
    chuaCoGiongCauHinh: "The server has no voices configured, so the bot won't read aloud. A Gemini key needs to be configured for the assistant service.",
    giongMacDinhChon: 'Default — the server picks the first voice',
    ngheThuGiong: 'Preview this voice',
    ngheThuMacDinh: 'Choose a specific voice to preview it — “Default” is chosen by the server at run time.',
  },

  troLyAiBotViDu: {
    kbTen: 'E.g. Open a credit card',
    kbTrigger: 'E.g. The customer wants to open a credit card',
    botTen: 'Water operations assistant',
    botMoTa: 'Answers operational questions and looks up internal rules.',
    botMucDich: 'Serves the operations team: monthly water loss figures and equipment warranty rules.',
    botHuongDan: "Answer briefly, in the first person. If something isn't in the documents or data, say plainly that you don't know.",
    khungTieuDe: 'Operations assistant',
    khungLoiChao: 'Hello! How can I help you?',
  },

  troLyAiBotQuyenDuLieu: {
    tieuDe: 'Data permissions',
    phuDe: 'Deny by default: without a grant nothing can be read, not even by administrators. Hidden columns are blocked everywhere in a query, not just in the output — filtering or sorting by a salary column is enough to leak it.',
    nguon: 'Data source',
    chiXem: 'View only',
    luuThayDoi: 'Save changes',
    daLuu: 'Saved',
    daLuuPhanQuyen: 'Permissions saved.',
    khongSuaDuoc: "Your role can't edit the permission matrix.",
    khongSuaDuocGhi: 'The permission matrix shows where sensitive data lives, so viewing it needs its own permission. You can still see your own permissions below.',
    chuaCoNguon: 'No data sources yet',
    chuaCoNguonMo: 'Add a source in Source connections first, then come back here to grant access.',
    sangKetNoi: 'Go to Source connections',
    vai: 'Roles',
    danhSachVai: 'Role list',
    khongCoVai: 'The organization has no roles yet.',
    mucQuyen: 'Access level for the role',
    mucNone: 'No access',
    mucTables: 'By table',
    mucFull: 'Whole source',
    canhBaoFull: 'Newly synced tables become readable immediately, without granting again.',
    fullMoTa: 'This role can read every table in the source, with no hidden columns.',
    chuaMoBang: 'This role has no table access yet. Choose “By table” to grant tables one by one.',
    tomTatNone: 'No access',
    tomTatFull: 'Whole source',
    tomTatChuaMo: 'No tables granted',
    tomTatBang: '{{n}} tables',
    tomTatBangGiau: '{{n}} tables · {{c}} columns hidden',
    nhanDong: 'not granted',
    nhanToanBo: 'whole source',
    nhanBang: '{{n}} tables',
    giauCot: '{{n}} columns hidden',
    soCot: '{{n}} columns',
    huongDanCotTruoc: 'Select a column to',
    huongDanCotDam: 'hide',
    huongDanCotSau: 'it. Highlighted columns are readable — including columns synced later.',
    dangGiau: 'Hidden — select to show',
    dangHien: 'Shown — select to hide',
    quyenCuaToi: 'Your current permissions',
    quyenCuaToiVai: 'Your current permissions — {{vai}}',
    giauDs: ' (hidden: {{ds}})',
    chuaCoNguonMoChoVai: 'No sources have been granted to this role. Access is denied until granted.',
    timBang: 'Search tables by name...',
    demBang: '{{mo}}/{{tong}} tables granted · showing {{hien}}',
    khongKhopBang: 'No tables match the filter.',
    tabTheoBang: 'By table and column',
    tabTheoKhuon: 'By query template',
    locBang: {
      tat_ca: 'All',
      da_mo: 'Granted',
      chua_mo: 'Not granted',
    },
  },

  troLyAiBotQuyenKhuon: {
    chuaCoKhuon: 'This source has no query templates yet',
    chuaCoKhuonMoTa: 'Go to Query templates to declare templates for this source first, then come back here to grant access.',
    dangNgu: "This source is declared by questions, so the matrix below isn't in effect yet. It takes effect as soon as you switch to declaring by query templates.",
    muc: 'Query template access level',
    mucNone: 'No query templates',
    mucFull: 'All query templates',
    mucChon: 'Selected groups and templates only',
    capRiengNhan: 'Grant individually',
    chanNhan: 'Block individually',
    chanViSao: 'Select a whole group to grant every template in it, or “Grant individually” per template. “Block individually” overrides both group and full grants.',
    chuaChayThuNhan: 'not test-run',
    chuaChayThuViSao: "Templates that haven't been test-run won't be used even when granted.",
    soKhuon: '{{n}} templates',
    luu: 'Save query template permissions',
    daLuu: 'Query template permissions saved.',
    tomTatNone: 'No templates granted',
    tomTatFull: 'All templates of the source',
    tomTatChon: '{{nhom}} groups · {{khuon}} templates',
    tomTatChan: '{{n}} templates blocked individually',
    duocDung: 'Usable',
    khongDung: 'Not usable',
  },
};
